/**
 * Product List Enova - Swiper initialization and Add to Cart functionality
 */

(function() {
  'use strict';

  // Store Swiper instances
  const swiperInstances = new Map();

  /**
   * Initialize Swiper for a section
   */
  function initSwiper(container) {
    if (!container || swiperInstances.has(container)) return;

    const sectionId = container.dataset.sectionId;
    const columnsDesktop = parseInt(container.dataset.columnsDesktop) || 4;
    const columnsTablet = parseInt(container.dataset.columnsTablet) || 3;
    const columnsMobile = parseFloat(container.dataset.columnsMobile) || 2;
    const spaceBetween = parseInt(container.dataset.spaceBetween) || 16;
    const autoplay = container.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(container.dataset.autoplaySpeed) || 5000;
    const loop = container.dataset.loop === 'true';

    const swiperConfig = {
      slidesPerView: columnsMobile,
      spaceBetween: spaceBetween,
      watchOverflow: true,
      breakpoints: {
        750: {
          slidesPerView: columnsTablet,
          spaceBetween: spaceBetween
        },
        990: {
          slidesPerView: columnsDesktop,
          spaceBetween: spaceBetween
        }
      },
      navigation: {
        nextEl: `.swiper-button-next-${sectionId}`,
        prevEl: `.swiper-button-prev-${sectionId}`
      },
      pagination: {
        el: `.swiper-pagination-${sectionId}`,
        clickable: true
      }
    };

    if (autoplay) {
      swiperConfig.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    if (loop) {
      swiperConfig.loop = true;
    }

    try {
      const swiper = new Swiper(container, swiperConfig);
      swiperInstances.set(container, swiper);
      console.log('[Enova Product List] Swiper initialized for section:', sectionId);
    } catch (error) {
      console.error('[Enova Product List] Error initializing Swiper:', error);
    }
  }

  /**
   * Initialize all Swiper instances on the page
   */
  function initAllSwipers() {
    const containers = document.querySelectorAll('.enova-product-list__swiper');
    containers.forEach(initSwiper);
  }

  /**
   * Add product to cart via AJAX
   */
  async function addToCart(variantId, button) {
    if (!variantId) {
      console.error('[Enova Product List] No variant ID provided');
      return;
    }

    // Show loading state
    button.classList.add('is-loading');
    button.disabled = true;

    const formData = {
      items: [{
        id: parseInt(variantId),
        quantity: 1
      }]
    };

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        // Check if it's a stock/quantity limit error
        const errorMessage = data.description || data.message || '';
        const isStockError = errorMessage.toLowerCase().includes('maximum') || 
                            errorMessage.toLowerCase().includes('inventory') ||
                            errorMessage.toLowerCase().includes('stock') ||
                            errorMessage.toLowerCase().includes('all') ||
                            response.status === 422;
        
        if (isStockError) {
          // Mark button as sold out (same visual as unavailable)
          markAsSoldOut(button);
          console.log('[Enova Product List] Stock limit reached:', errorMessage);
        } else {
          // Generic error feedback
          button.classList.add('is-error');
          setTimeout(() => {
            button.classList.remove('is-error');
            button.disabled = false;
          }, 2000);
        }
        
        button.classList.remove('is-loading');
        return;
      }

      console.log('[Enova Product List] Product added:', data);

      // Update cart count in header
      updateCartCount();

      // Open cart drawer
      await openCartDrawer();

      // Success feedback
      button.classList.add('is-success');
      setTimeout(() => {
        button.classList.remove('is-success');
      }, 2000);

      // Reset loading state
      button.classList.remove('is-loading');
      button.disabled = false;

    } catch (error) {
      console.error('[Enova Product List] Error adding to cart:', error);
      
      // Error feedback
      button.classList.add('is-error');
      setTimeout(() => {
        button.classList.remove('is-error');
      }, 2000);
      
      // Reset loading state
      button.classList.remove('is-loading');
      button.disabled = false;
    }
  }

  /**
   * Mark a size button as sold out (visually disabled)
   */
  function markAsSoldOut(button) {
    button.classList.remove('is-loading', 'is-error', 'is-success');
    button.classList.add('enova-product-card__size-btn--disabled');
    button.disabled = true;
  }

  /**
   * Update cart count in header
   */
  async function updateCartCount() {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js', {
        credentials: 'same-origin'
      });
      const cart = await response.json();
      
      // Update cart count badge
      const cartCountElements = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
      cartCountElements.forEach(el => {
        el.textContent = cart.item_count;
      });

      // Show cart count bubble if items > 0
      const cartBubbles = document.querySelectorAll('.cart-count-bubble');
      cartBubbles.forEach(bubble => {
        if (cart.item_count > 0) {
          bubble.classList.remove('hidden');
        } else {
          bubble.classList.add('hidden');
        }
      });

      // Update $Cart if exists (Vue system)
      if (window.$Cart && typeof window.$Cart.get === 'function') {
        window.$Cart.get();
      }

    } catch (error) {
      console.error('[Enova Product List] Error updating cart count:', error);
    }
  }

  /**
   * Open the cart drawer
   */
  async function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      console.log('[Enova Product List] Cart drawer not found');
      return;
    }

    try {
      // Fetch updated cart sections
      const sections = 'cart-drawer,cart-icon-bubble';
      const response = await fetch(`${window.Shopify.routes.root}?sections=${sections}`, {
        credentials: 'same-origin'
      });
      const sectionsData = await response.json();

      // Use native Dawn method if available
      if (typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents({ sections: sectionsData });
      } else {
        // Manual fallback
        updateCartDrawerManually(sectionsData);
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }

      // Remove is-empty class
      removeEmptyClass();
      setTimeout(removeEmptyClass, 100);

    } catch (error) {
      console.error('[Enova Product List] Error opening cart drawer:', error);
      // Fallback: just open the drawer
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    }
  }

  /**
   * Manual update of cart drawer as fallback
   */
  function updateCartDrawerManually(sectionsData) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    if (sectionsData['cart-drawer']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionsData['cart-drawer'], 'text/html');
      const newDrawer = doc.getElementById('CartDrawer');
      const currentDrawer = document.getElementById('CartDrawer');
      
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }
    }

    if (sectionsData['cart-icon-bubble']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionsData['cart-icon-bubble'], 'text/html');
      const newIcon = doc.querySelector('.shopify-section');
      const currentIcon = document.getElementById('cart-icon-bubble');
      
      if (newIcon && currentIcon) {
        const container = currentIcon.closest('.shopify-section');
        if (container) {
          container.innerHTML = newIcon.innerHTML;
        }
      }
    }
  }

  /**
   * Remove is-empty class from cart elements
   */
  function removeEmptyClass() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.remove('is-empty');
      cartDrawer.querySelectorAll('.is-empty').forEach(el => {
        el.classList.remove('is-empty');
      });
    }
    
    document.querySelectorAll('.drawer.is-empty, .drawer__inner.is-empty, cart-drawer-items.is-empty, cart-items.is-empty').forEach(el => {
      el.classList.remove('is-empty');
    });
  }

  /**
   * Handle click events for quick add buttons
   */
  function handleQuickAddClick(event) {
    // Handle size button click
    const sizeButton = event.target.closest('.enova-product-card__size-btn');
    if (sizeButton && !sizeButton.disabled) {
      event.preventDefault();
      event.stopPropagation();
      const variantId = sizeButton.dataset.variantId;
      addToCart(variantId, sizeButton);
      return;
    }

    // Handle single add button click (for products without size options)
    const singleAddButton = event.target.closest('.enova-product-card__quick-add-single');
    if (singleAddButton && !singleAddButton.disabled) {
      event.preventDefault();
      event.stopPropagation();
      const variantId = singleAddButton.dataset.variantId;
      addToCart(variantId, singleAddButton);
      return;
    }
  }

  /**
   * Handle hover/touch for quick add trigger
   */
  function handleQuickAddHover() {
    // Check if device supports hover
    const hasHover = window.matchMedia('(hover: hover)').matches;

    if (hasHover) {
      // Desktop: hover functionality
      document.addEventListener('mouseenter', function(event) {
        const trigger = event.target.closest('.enova-product-card__quick-add-trigger');
        if (trigger && !trigger.classList.contains('enova-product-card__quick-add-single')) {
          const quickAdd = trigger.closest('.enova-product-card__quick-add');
          if (quickAdd) {
            quickAdd.classList.add('is-expanded');
          }
        }
      }, true);

      // Hide sizes when leaving the quick add area
      document.addEventListener('mouseleave', function(event) {
        const quickAdd = event.target.closest('.enova-product-card__quick-add');
        if (quickAdd && !quickAdd.contains(event.relatedTarget)) {
          quickAdd.classList.remove('is-expanded');
        }
      }, true);
    }

    // Click handler for trigger (works on mobile and desktop)
    document.addEventListener('click', function(event) {
      const trigger = event.target.closest('.enova-product-card__quick-add-trigger');
      
      // If clicking on trigger (not single variant button)
      if (trigger && !trigger.classList.contains('enova-product-card__quick-add-single')) {
        // IMPORTANTE: Prevenir INMEDIATAMENTE cualquier propagación
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        const quickAdd = trigger.closest('.enova-product-card__quick-add');
        
        if (quickAdd) {
          // Close other open quick adds
          document.querySelectorAll('.enova-product-card__quick-add.is-expanded').forEach(el => {
            if (el !== quickAdd) {
              el.classList.remove('is-expanded');
            }
          });
          // Toggle current one
          quickAdd.classList.toggle('is-expanded');
          console.log('[Enova] Size selector toggled. Expanded:', quickAdd.classList.contains('is-expanded'));
        }
        return false; // Extra prevención
      }

      // Close quick adds when clicking outside
      if (!event.target.closest('.enova-product-card__quick-add')) {
        document.querySelectorAll('.enova-product-card__quick-add.is-expanded').forEach(el => {
          el.classList.remove('is-expanded');
        });
      }
    }, true);
  }

  /**
   * Initialize event listeners
   */
  function initEventListeners() {
    // Add to cart click handler
    document.addEventListener('click', handleQuickAddClick, true);
    
    // Quick add hover/touch handler
    handleQuickAddHover();

    // Check cart for already maxed out variants (with delay for Swiper to finish)
    setTimeout(() => {
      checkCartForMaxedVariants();
    }, 500);

    console.log('[Enova Product List] Event listeners initialized');
  }

  /**
   * Check cart and disable variants that are already at max quantity
   */
  async function checkCartForMaxedVariants() {
    try {
      console.log('[Enova Product List] Checking cart for maxed variants...');
      
      // Step 1: Get cart
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {
        credentials: 'same-origin'
      });
      const cart = await cartResponse.json();

      console.log('[Enova Product List] Cart items:', cart.items?.length || 0);

      if (!cart.items || cart.items.length === 0) return;

      // Step 2: Create a map of variant IDs to cart quantities
      const cartVariants = {};
      cart.items.forEach(item => {
        cartVariants[item.variant_id] = item.quantity;
      });

      console.log('[Enova Product List] Cart variants:', cartVariants);

      // Step 3: Get unique product handles that have items in cart
      const productHandles = new Set();
      cart.items.forEach(item => {
        if (item.handle) {
          productHandles.add(item.handle);
        }
      });

      // Step 4: Fetch product data and build variant inventory map
      const variantInventory = {};
      
      for (const handle of productHandles) {
        try {
          const productResponse = await fetch(`${window.Shopify.routes.root}products/${handle}.js`);
          if (productResponse.ok) {
            const product = await productResponse.json();
            product.variants.forEach(variant => {
              variantInventory[variant.id] = {
                available: variant.available,
                inventory_quantity: variant.inventory_quantity,
                inventory_management: variant.inventory_management
              };
            });
            console.log('[Enova Product List] Loaded product:', handle);
          }
        } catch (e) {
          console.error('[Enova Product List] Error loading product:', handle, e);
        }
      }

      console.log('[Enova Product List] Variant inventory:', variantInventory);

      // Step 5: Now disable all buttons for maxed variants
      const allSizeButtons = document.querySelectorAll('.enova-product-list .enova-product-card__size-btn');
      
      console.log('[Enova Product List] Found size buttons:', allSizeButtons.length);

      allSizeButtons.forEach(button => {
        const variantId = parseInt(button.dataset.variantId);
        const cartQuantity = cartVariants[variantId] || 0;
        const inventory = variantInventory[variantId];

        if (cartQuantity > 0 && inventory) {
          const isMaxed = !inventory.available || 
                         (inventory.inventory_management && 
                          inventory.inventory_quantity !== null && 
                          cartQuantity >= inventory.inventory_quantity);
          
          if (isMaxed) {
            markAsSoldOut(button);
            console.log(`[Enova Product List] Disabled variant ${variantId} (cart: ${cartQuantity}, inventory: ${inventory.inventory_quantity})`);
          }
        }
      });

    } catch (error) {
      console.error('[Enova Product List] Error checking cart:', error);
    }
  }

  /**
   * Handle Shopify theme editor events
   */
  function initThemeEditor() {
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        const section = event.target;
        const container = section.querySelector('.enova-product-list__swiper');
        if (container) {
          // Destroy existing instance if any
          const existingSwiper = swiperInstances.get(container);
          if (existingSwiper) {
            existingSwiper.destroy();
            swiperInstances.delete(container);
          }
          // Reinitialize
          setTimeout(() => initSwiper(container), 100);
        }
      });

      document.addEventListener('shopify:section:unload', function(event) {
        const section = event.target;
        const container = section.querySelector('.enova-product-list__swiper');
        if (container) {
          const swiper = swiperInstances.get(container);
          if (swiper) {
            swiper.destroy();
            swiperInstances.delete(container);
          }
        }
      });
    }
  }

  /**
   * Load Swiper from CDN if not already loaded
   */
  function loadSwiper(callback) {
    // Check if Swiper is already available
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    // Check if Swiper script is already loading
    const existingScript = document.querySelector('script[src*="swiper"]');
    if (existingScript) {
      // Wait for existing script to load
      existingScript.addEventListener('load', callback);
      // In case it's already loaded
      if (typeof Swiper !== 'undefined') {
        callback();
      }
      return;
    }

    // Load Swiper CSS if not loaded
    if (!document.querySelector('link[href*="swiper"]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      document.head.appendChild(link);
    }

    // Load Swiper JS
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.onload = callback;
    document.head.appendChild(script);
  }

  /**
   * Main initialization
   */
  function init() {
    // Load Swiper and then initialize
    loadSwiper(function() {
      // Double check Swiper is available
      if (typeof Swiper === 'undefined') {
        console.log('[Enova Product List] Waiting for Swiper...');
        setTimeout(init, 100);
        return;
      }

      initAllSwipers();
      initEventListeners();
      initThemeEditor();
      
      console.log('[Enova Product List] Initialized');
    });
  }

  // Start initialization when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

